'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Location = require('./Location');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Location).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Location/index.js
// module id = 1226
// module chunks = 1